// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"292":"18653aa1","334":"4cf18444","441":"93d93396","453":"ed3810f9","721":"a2191f2b"}[chunkId] + ".chunk.js";
};